<h1 mat-dialog-title>{{ title }}</h1>
<div *ngIf="actionDescription" mat-dialog-content >
  <p>{{ actionDescription }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{ cancelButtonText }}</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>{{ confirmButtonText }}</button>
</div>
